import { getDepartmentPdfExport } from '../apis/appointment';
import { useQuery } from '@tanstack/react-query';

const fetchDepartmentPdf = async (
  departmentSlug?: string
): Promise<Blob | null> => {
  if (!departmentSlug) {
    console.error('No department slug provided to fetch PDF.');
    return null;
  }

  try {
    const response = await getDepartmentPdfExport(departmentSlug);
    return response;
  } catch (error) {
    console.error('There was an error trying to get the PDF:', error);
    return null;
  }
};

export function useDepartmentPdf(departmentSlug?: string) {
  return useQuery({
    queryKey: ['departmentPdf', departmentSlug],
    queryFn: () => fetchDepartmentPdf(departmentSlug),
    enabled: false,
  });
}
